export default __webpack_public_path__ + "static/media/cur_mapa.9e8e6d87.png";